import {
  isString,
  SDate
} from '@summit/core';

import { FilterParameter } from './filter-parameter';
import { IProfile } from './i-profile';

export class SummitCoreHelpers {
  static GenerateQueryString(filterParameters: FilterParameter[], activeProfile: IProfile | null): string | null {
    if (!filterParameters) {
      return '';
    }
    let oDataFilterString = '';
    const extraFilterString = new Array<string>();
    // console.log(`FilterParameters = `, filterParameters);
    filterParameters
      .filter((item) => item.state === true)
      .forEach((entry) => {
        //console.log(`Processing`, entry);
        if (entry.oDataFilter && (entry.filterData || entry.oDataFilter.indexOf(`[${entry.id}]`) === -1)) {
          if (oDataFilterString.length > 0) {
            oDataFilterString += ' and ';
          }
          let newFilter = `(${entry.oDataFilter})`;
          // console.log(`Adding ${newFilter}`);
          if (entry.filterData) {
            //console.log(`Adding ${newFilter} with filterData = ${entry.filterData}`);
            if (typeof entry.filterData === 'string') {
              //console.log('newFilter:', newFilter, entry.id, entry.filterData);
              const regEx = new RegExp('\\[' + entry.id + '\\]', 'g');
              //console.log("regex", regEx)
              newFilter = newFilter.replace(regEx, entry.filterData);
              //console.log("final filter", newFilter)
            } else if (typeof entry.filterData === 'number') {
              console.log('newFilter: number ', newFilter, entry.id, entry.filterData);
              const regEx = new RegExp('\\[' + entry.id + '\\]', 'g');
              //console.log("regex", regEx)
              newFilter = newFilter.replace(regEx, entry.filterData.toString());
              //console.log("final filter", newFilter)
            } else {
              for (const prop in entry.filterData) {
                if (Object.prototype.hasOwnProperty.call(entry.filterData, prop)) {
                  //console.log(`Looking at property ${prop}: ${typeof entry.filterData[prop]}`, entry.filterData[prop]);
                  if (SDate.newUtc(entry.filterData[prop]).isValid()) {
                    const tempMoment = SDate.newUtc(entry.filterData[prop]);
                    // console.log(`Replacing Date ${prop} = ${tempMoment.format('YYYY-MM-DD')}`);
                    if (prop.match(/time/i)) {
                      newFilter = newFilter.replace(
                        `[${prop}]`,
                        tempMoment.format('YYYY-MM-DD[T]HH:mm:ss.SSS[%2B]00:00')
                      );
                    } else {
                      newFilter = newFilter.replace(`[${prop}]`, tempMoment.format('YYYY-MM-DD'));
                    }
                  } else {
                    // console.log(`Replacing ${prop} = ${entry.filterData[prop]}`);
                    newFilter = newFilter.replace(`[${prop}]`, entry.filterData[prop]);
                  }
                }
              }
            }
            // console.log(`Update To ${newFilter}`);
          }
          oDataFilterString += newFilter;
        } else {
          if (entry.filterData) {
            if (isString(entry.filterData)) extraFilterString.push(`${entry.id}=${entry.filterData}`);
            else extraFilterString.push(`${entry.id}=${JSON.stringify(entry.filterData)}`);
          }
        }
      });
    // Auto change <SELF> to current EmployeeID
    if (activeProfile) {
      // console.log(`[SummitCoreHelpers] Replacing <Self> values with current Profile values`);
      oDataFilterString = oDataFilterString.replace(new RegExp('<SELF>', 'g'), activeProfile.id);
      oDataFilterString = oDataFilterString.replace('<SELF.FedEx>', activeProfile.fedExID);
      oDataFilterString = oDataFilterString.replace('<SELF.TenantID>', activeProfile.tenantID);
    } else {
      if (oDataFilterString.indexOf('<SELF>') > -1) {
        //console.warn(`[SummitCoreHelpers] Unable to replace <SELF> values with current Profile values because activeProfile is null`);
        return null;
      }
      if (oDataFilterString.indexOf('<SELF.FedEx>') > -1) {
        /*console.warn(
          `[SummitCoreHelpers] Unable to replace <SELF.FedEx> values with current Profile values because activeProfile is null`
          );
          */
        return null;
      }
      if (oDataFilterString.indexOf('<SELF.TenantID>') > -1) {
        /*console.warn(
          `[SummitCoreHelpers] Unable to replace <SELF.TenantID> values with current Profile values because activeProfile is null`
        );
        */
        return null;
      }
    }
    if (oDataFilterString.length > 0) {
      oDataFilterString = `$filter=${oDataFilterString}`;
    }
    // console.log(`Generated odataFilterString: ${oDataFilterString}`);
    let response = '?';
    if (oDataFilterString.length > 0) {
      response += oDataFilterString;
    }
    if (extraFilterString.length > 0) {
      if (response.length > 1) {
        response += '&';
      }
      response += extraFilterString.join('&');
    }

    return response.length > 1 ? response : '';
  }
}
